var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('render-input',{attrs:{"input":_vm.fieldConfig.section}}),_c('TableWithAddRecord',{attrs:{"rows":_vm.rows},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }